import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logoMain from "../Assets/logo.png";
import TextStrip from "../TextStrip/TextStrip";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const openMenu = () => setMenuOpen(true);
  const closeMenu = () => setMenuOpen(false);

  // Close menu on route change
  useEffect(() => {
    closeMenu();
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && menuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [menuOpen]);

  return (
    <>
      <nav className="navbar">
        <div className="page-wrapper">
          {/* Logo */}
          <div className="navbar-logo">
            <Link to="/" className="navbar-logo-link">
              <img
                src={logoMain}
                alt="Onenessweb Solution Logo"
                className="navbar-logo-img"
              />
            </Link>
          </div>

          {/* Hamburger Icon - Only for opening */}
          <button
            className="navbar-hamburger"
            onClick={openMenu}
            aria-label="Open navigation menu"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Overlay for mobile menu */}
          {menuOpen && (
            <div className="navbar-overlay" onClick={closeMenu}></div>
          )}

          {/* Navigation Links */}
          <ul className={`navbar-links ${menuOpen ? "navbar-links-open" : ""}`}>
            {/* Close Button inside sidebar */}
            <button
              className="navbar-close-btn"
              onClick={closeMenu}
              aria-label="Close navigation menu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            {/* Logo in sidebar */}
            {/* <li className="navbar-mobile-logo">
              <Link to="/" onClick={closeMenu}>
                <img src={logoMain} alt="Onenessweb Solution" />
              </Link>
            </li> */}

            <li className="navbar-item">
              <Link to="/" onClick={closeMenu} className="navbar-link">
                Home
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/about" onClick={closeMenu} className="navbar-link">
                About
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/services" onClick={closeMenu} className="navbar-link">
                Services
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/portfolio" onClick={closeMenu} className="navbar-link">
                Our Work
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/blog" onClick={closeMenu} className="navbar-link">
                Blog
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/careers" onClick={closeMenu} className="navbar-link">
                Careers
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/contact" onClick={closeMenu} className="navbar-link">
                Contact Us
              </Link>
            </li>

            {/* Mobile CTA Button inside menu */}
            <li className="navbar-item navbar-mobile-btn-item">
              <Link
                to="/contact"
                onClick={closeMenu}
                className="navbar-btn navbar-mobile-btn"
              >
                Let's Talk
              </Link>
            </li>
          </ul>

          {/* Desktop CTA Button */}
          <Link to="/contact" className="navbar-btn navbar-desktop-btn">
            Let's Talk
          </Link>
        </div>
      </nav>
      <TextStrip
        homeStrips={[
          "Our Internship Batch for 2026-27 is Open.",
          "Contact Us on WhatsApp: +91-9978611325",
        ]}
      />
    </>
  );
};

export default Navbar;
